import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

function LegalLayout({ title, testId, children }) {
  return (
    <div className="min-h-screen bg-[#050505] px-6 pb-24 pt-16 text-[#F5F5F0] md:px-12" data-testid={testId}>
      <div className="mx-auto max-w-3xl">
        <Link
          to="/"
          data-testid="legal-back-link"
          className="inline-flex items-center gap-2 text-xs tracking-[0.25em] text-[#A0A0A0] transition-colors hover:text-[#FFD700]"
        >
          <ArrowLeft size={13} /> ZURÜCK ZUR WEBSITE
        </Link>
        <span className="gold-text mt-14 block font-serif-accent text-3xl">S&F</span>
        <h1 className="mt-4 font-display text-4xl font-extrabold uppercase tracking-tight md:text-5xl">
          {title}
        </h1>
        <div className="mt-10 space-y-10 text-base font-light leading-relaxed text-[#A0A0A0]">
          {children}
        </div>
      </div>
    </div>
  );
}

function Block({ title, children }) {
  return (
    <section>
      <h2 className="mb-3 font-display text-lg font-bold uppercase tracking-wide text-[#F5F5F0]">
        {title}
      </h2>
      {children}
    </section>
  );
}

export function Impressum() {
  return (
    <LegalLayout title="Impressum" testId="impressum-page">
      <Block title="Angaben gemäß § 5 DDG">
        <p>
          S&F Webdesign
          <br />
          Inhaber: Fabio Liebold und Santo Panella
          <br />
          Maximilianstraße 57
          <br />
          86150 Augsburg
        </p>
      </Block>
      <Block title="Kontakt">
        <p>
          Telefon: +49 177 4857657
          <br />
          E-Mail: kontakt@sf-webseiten.de
        </p>
      </Block>
      <Block title="Umsatzsteuer">
        <p>
          Als Kleinunternehmen im Sinne des § 19 Umsatzsteuergesetz wird keine Umsatzsteuer
          berechnet und dementsprechend nicht ausgewiesen.
        </p>
      </Block>
      <Block title="Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV">
        <p>
          Fabio Liebold und Santo Panella, Anschrift wie oben
        </p>
      </Block>
      <Block title="Haftung für Inhalte">
        <p>
          Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die Richtigkeit,
          Vollständigkeit und Aktualität der Inhalte kann jedoch keine Gewähr übernommen werden.
          Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten
          nach den allgemeinen Gesetzen verantwortlich.
        </p>
      </Block>
      <Block title="Haftung für Links">
        <p>
          Diese Website enthält ggf. Links zu externen Websites Dritter, auf deren Inhalte wir
          keinen Einfluss haben. Für die Inhalte der verlinkten Seiten ist stets der jeweilige
          Anbieter oder Betreiber verantwortlich.
        </p>
      </Block>
      <Block title="Urheberrecht">
        <p>
          Die durch uns erstellten Inhalte und Werke auf dieser Website unterliegen dem deutschen
          Urheberrecht. Vervielfältigung, Bearbeitung und Verbreitung außerhalb der Grenzen des
          Urheberrechtes bedürfen unserer schriftlichen Zustimmung.
        </p>
      </Block>
    </LegalLayout>
  );
}

export function Datenschutz() {
  return (
    <LegalLayout title="Datenschutz" testId="datenschutz-page">
      <Block title="1. Verantwortlicher">
        <p>
          Verantwortlich für die Datenverarbeitung auf dieser Website ist:
          <br />
          S&F Webdesign, Fabio Liebold und Santo Panella, Maximilianstraße 57,
          86150 Augsburg,
          E-Mail: kontakt@sf-webseiten.de
        </p>
      </Block>
      <Block title="2. Hosting">
        <p>
          Diese Website wird bei einem externen Dienstleister gehostet. Beim Aufruf der Seiten
          werden durch den Hosting-Anbieter automatisch Verbindungsdaten (z. B. IP-Adresse,
          Zeitpunkt, Browsertyp) in Server-Logfiles verarbeitet. Rechtsgrundlage ist Art. 6
          Abs. 1 lit. f DSGVO (berechtigtes Interesse am sicheren Betrieb der Website).
        </p>
      </Block>
      <Block title="3. Kontaktformular">
        <p>
          Bei Nutzung des Kontaktformulars verarbeiten wir die von Ihnen angegebenen Daten (Name,
          E-Mail-Adresse, ggf. Unternehmen und Ihre Nachricht), um Ihre Anfrage zu beantworten.
          Die Übermittlung erfolgt über den Formulardienst unseres Hosting-Anbieters, der die
          Anfrage entgegennimmt und an uns weiterleitet. Rechtsgrundlage ist Art. 6 Abs. 1
          lit. b DSGVO (vorvertragliche Maßnahmen). Eine darüber hinausgehende Weitergabe an
          Dritte erfolgt nicht. Sie können die Löschung Ihrer Daten jederzeit per E-Mail
          verlangen.
        </p>
      </Block>
      <Block title="4. Schriftarten und externe Inhalte">
        <p>
          Zur Darstellung der Website laden wir Schriftarten von Google Fonts und Fontshare sowie
          Bilddateien von den Bild-CDNs Unsplash und Pexels. Dabei wird Ihre IP-Adresse an die
          jeweiligen Anbieter übertragen. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO
          (berechtigtes Interesse an einer einheitlichen und performanten Darstellung).
        </p>
      </Block>
      <Block title="5. Lokale Speicherung">
        <p>
          Diese Website verwendet keine Tracking-Cookies und kein Analyse-Tool. Es wird
          ausschließlich eine technisch notwendige Information im Session Storage Ihres Browsers
          abgelegt, damit die Intro-Animation bei wiederholten Seitenaufrufen nicht erneut
          abgespielt wird. Diese Information wird beim Schließen des Browsers automatisch gelöscht.
        </p>
      </Block>
      <Block title="6. Ihre Rechte">
        <p>
          Sie haben jederzeit das Recht auf Auskunft über Ihre gespeicherten personenbezogenen
          Daten sowie auf Berichtigung, Löschung, Einschränkung der Verarbeitung,
          Datenübertragbarkeit und Widerspruch (Art. 15–21 DSGVO). Zudem besteht ein
          Beschwerderecht bei der zuständigen Aufsichtsbehörde — für Bayern: Bayerisches Landesamt
          für Datenschutzaufsicht (BayLDA), Promenade 18, 91522 Ansbach.
        </p>
      </Block>
      <Block title="7. SSL/TLS-Verschlüsselung">
        <p>
          Diese Website nutzt aus Sicherheitsgründen eine SSL- bzw. TLS-Verschlüsselung. Eine
          verschlüsselte Verbindung erkennen Sie an „https://" in der Adresszeile Ihres Browsers.
        </p>
      </Block>
    </LegalLayout>
  );
}
